import React from "react";
import {Col, Row} from "react-bootstrap";
import {BsFacebook, BsInstagram, BsLinkedin, BsTiktok, BsYoutube} from "react-icons/bs";
import {useTranslation} from "react-i18next";
import {SocialIcons} from "../common/SocialIcons";

const socialLinks = [
    {
        name: "Instagram",
        url: "https://www.instagram.com/dmarcflow",
        icon: <BsInstagram/>,
    },
    {
        name: "LinkedIn",
        url: "https://www.linkedin.com/company/dmarcflow",
        icon: <BsLinkedin/>,
    },
    {
        name: "TikTok",
        url: "https://www.tiktok.com/@dmarcflow",
        icon: <BsTiktok/>,
    },
    {
        name: "Facebook",
        url: "https://www.facebook.com/people/DMARCflow",
        icon: <BsFacebook/>,
    },
    {
        name: "YouTube",
        url: "https://www.youtube.com/@dmarcflow",
        icon: <BsYoutube/>,
    },
];

export const FollowUs = () => {
    const {t} = useTranslation();

    return (
        <section
            className="py-5"
            aria-labelledby="social"
        >
            <Row className="justify-content-center text-center">
                <Col lg={8}>
                    <h2 id="social" className="fw-bold mb-3">
                        {t("pages.home.followUs.title")}
                    </h2>
                    <p className="text-muted mb-4">
                        {t("pages.home.followUs.description")}
                    </p>
                    <div className="d-flex justify-content-center gap-4 fs-3 flex-wrap">
                        <SocialIcons size={"40"} color={"text-black"}></SocialIcons>
                    </div>
                </Col>
            </Row>
        </section>
    );
};
